var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "upgrade-needed",
        "show-footer": false,
        "show-title": false,
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c("div", { staticClass: "upgrade-needed-container" }, [
        _c(
          "div",
          { staticClass: "upgrade-plan-container" },
          [
            _c("UpgradeSVG", {
              staticClass: "upgrade-svg",
              class: { upgrading: _vm.startAnimation },
            }),
            _vm._v(" "),
            _c("UpgradeSVG", {
              staticClass: "upgrade-svg",
              class: { upgrading: _vm.startAnimation },
            }),
            _vm._v(" "),
            _c("UpgradeSVG", {
              staticClass: "upgrade-svg",
              class: { upgrading: _vm.startAnimation },
            }),
            _vm._v(" "),
            _c("Card", {
              staticClass: "plan",
              attrs: {
                plan: _vm.nextPlan,
                period: _vm.period,
                details: _vm.details,
                plans: _vm.plans,
                "current-plans": [_vm.nextPlan],
                "is-selected": true,
                "is-readonly": true,
                "show-details": true,
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upgrade-needed-footer" },
        [
          _c(
            "SupsisButton",
            { attrs: { ghost: "" }, on: { click: _vm.cancel } },
            [_vm._v("İptal Et")]
          ),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.upgrade } },
            [_vm._v("Onayla")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }